import { useQuery } from '@tanstack/react-query';

import { DataLakeQuery } from '@graylog/enterprise-api';

import type { ActivePreviewSearch } from 'data-lake/preview/Types';
import { INITIAL_PAGE, PAGE_SIZE, DATA_LAKE_PREVIEW_QUERY_KEY } from 'data-lake/preview/Constants';

const useFetchActiveSearch = (
  enabled = true,
): {
  data: ActivePreviewSearch | undefined;
  isFetching?: boolean;
  refetch: () => Promise<unknown>;
} =>
  useQuery({
    queryKey: [DATA_LAKE_PREVIEW_QUERY_KEY, 'active-query'],
    queryFn: () => DataLakeQuery.activeQuery(INITIAL_PAGE, PAGE_SIZE),
    retry: 0,
    enabled,
  });

export default useFetchActiveSearch;
